/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'
import * as S from './styles'
import { useForm } from 'react-hook-form'

import { toast } from 'react-toastify'

// GRID
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

// COMPONENTS
import SelectField, { ChangeSelectProps } from '../../SelectField'
import TextField from '../../InputForms/TextField'
import Button from '../../Button'

import { useFetch } from '../../../lib/hooks/useFetch'
import { AxiosHttpClient } from '../../../resources/http'
import { IdentifierProps } from '../../../types/stock'
import { ProvidersProps } from '../../../types/providers'
import { GroupTypeBase } from 'react-select'
import Spinner from '../../Spinner'
import { useAgainstSample } from 'store'
import { UserInfo } from '../../TableDefault/tables'
import CheckBoxField from 'components/InputForms/CheckField'

type Options =
  | (ChangeSelectProps | GroupTypeBase<ChangeSelectProps>)[]
  | (undefined & {
      value: string | number
      label: string | number
    })

export type FormModelingProps = {
  identifier: IdentifierProps
  children?: React.ReactChild
  close: () => void
}

const FormRealocation = ({ identifier, close }: FormModelingProps) => {
  const { register, handleSubmit } = useForm()
  const [options, setOptions] = useState<Options>([])
  const [activeItemName, setActiveItemName] = useState<any[]>()
  const [userInfo, setuserInfo] = useState<UserInfo>()

  const [values, setValues] = useState({
    idProduct: identifier.idProduct,
    idUser: identifier.idUser,
    provider: identifier.provider,
    realocation: false,
    realocationDate: '',
    reseal: false,
    resealDate: '',
    realocationProvider: ''
  })

  const { clearAll }: any = useAgainstSample()

  useEffect(() => {
    if (localStorage.getItem('userInfo')) {
      const userStrings = localStorage.getItem('userInfo')
      let userInfo: UserInfo

      if (userStrings) {
        const userObject: UserInfo = JSON.parse(userStrings)

        userInfo = userObject
        setuserInfo(userInfo)
      }
    }

    const main = async () => {
      await ajax()
    }

    main()
  }, [])

  const ajax = async () => {
    const http = new AxiosHttpClient()
    const response = await http.request<any[]>(
      `/product/${identifier.idProduct}`,
      {
        body: {},
        method: 'get',
        headers: {
          authorization: localStorage.getItem('userToken')
        }
      }
    )

    if (response && response.body) {
      const newvalues = values
      setActiveItemName(response.body)
      if (response.body.length > 0) {
        const isRealocation = response.body[0].realocation === 1 ? true : false;
        const isReseal = response.body[0].reseal === 1 ? true : false;
        setValues({
          ...newvalues,
          realocation: response.body[0].realocation === 1 ? true : false,
          reseal: response.body[0].reseal === 1 ? true : false,
          resealDate: isReseal ? response.body[0].reseal_date : '',
          realocationDate: isRealocation ? response.body[0].realocation_date : '',
          realocationProvider: isRealocation ? response.body[0].realocation_provider : ''
        })
        response.body[0].reseal === 1 ? setShowResealDateField(true) : setShowResealDateField(false)
        response.body[0].realocation === 1 ? setShowRealocationDateField(true) : setShowRealocationDateField(false)
      }
    }
  }

  const { data } = useFetch<ProvidersProps[]>(
    {
      url: `/estoque/providers_list`,
      method: 'GET',
      headers: {
        authorization: localStorage.getItem('userToken')
      }
    },
    {
      initialData: [],
      revalidateOnFocus: false
    }
  )

  const onSubmit = () => {
    const {
      provider,
      idProduct,
      realocation,
      realocationDate,
      reseal,
      resealDate,
      realocationProvider
    } = values

    const request = {
      provider: provider,
      code: identifier.ref
        ? identifier.ref
        : activeItemName && activeItemName[0] && activeItemName[0].code
        ? activeItemName[0].code
        : identifier.ref,
      productId: idProduct,
      userId: userInfo?.id_usuario || identifier.idUser,
      realocation:
        realocation !== null || undefined
          ? realocation
          : activeItemName && activeItemName[0] && activeItemName[0].realocation === 1
          ? true
          : false,
      realocationDate: realocationDate ? realocationDate : null,
      reseal:
        reseal !== null || undefined
          ? reseal
          : activeItemName && activeItemName[0] && activeItemName[0].reseal === 1
          ? true
          : false,
      resealDate: resealDate ? resealDate : null,
      realocationProvider: realocationProvider
        ? realocationProvider
        : activeItemName && activeItemName[0] && activeItemName[0].realocationProvider
        ? activeItemName[0].realocationProvider
        : null,
    }

    handleModeling(request)
  }

  const [showRealocationDateField, setShowRealocationDateField] = useState( false );
  const [showResealDateField, setShowResealDateField] = useState( false );

  const handleInput = (field: string, values: any) => {
    if (field === 'realocation') {
      setValues((s) => ({ 
        ...s, 
        [field]: values,
        realocationDate: values ? s.realocationDate : '',
        realocationProvider: values ? s.realocationProvider : ''
      }))
      setShowRealocationDateField(values)
    } else if (field === 'reseal') {
      setValues((s) => ({ 
        ...s, 
        [field]: values,
        resealDate: values ? s.resealDate : ''
      }))
      setShowResealDateField(values)
    } else {
      setValues((s) => ({ ...s, [field]: values }))
    }
  }



  const handleModeling = async (data: any) => {
    const http = new AxiosHttpClient()
    const response = await http.request('/estoque_realocacao', {
      body: data,
      method: 'post',
      headers: {
        authorization: localStorage.getItem('userToken')
      }
    })

    await clearAll()
    if (response && response.statusCode === 200) {
      toast.success('Produto realocado/relacrado com sucesso !')

      close()
    }

    if (response && response.statusCode === 404) {
      toast.warning('Preencha os campos corretamente!')

      close()
    } else {
      if (response && response.statusCode === 500) {
        toast.error('Um problema inesperado ocorreu favor recarregar a página!')

        close()
      }
    }
  }

  useEffect(() => {
      if (data) {
        setOptions(
          data.map((option: any) => {
            return {
              value: option.provider,
              label: option.provider
            }
          })
        )
      }
    }, [data])

  return (
    <>
      <S.Wrapper>
        <Container fluid>
          {activeItemName && activeItemName.length >= 0 ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col md={{ span: 6 }}>
                  <div className="checkbox_container">
                    <CheckBoxField
                      {...register('realocation')}
                      onChange={(value) => handleInput('realocation', value)}
                      fieldName="realocação"
                      initialValue={
                        activeItemName[0] && activeItemName[0].realocation === 1
                          ? true
                          : false
                      }
                    />
                    {showRealocationDateField && (
                    <TextField
                      {...register('realocationDate')}
                      type="date"
                      onChange={(value) => handleInput('realocationDate', value)}
                      fieldName="data realocação"
                      initialValue={
                        activeItemName && activeItemName[0]
                          ? activeItemName[0].realocation_date
                          : null
                      }
                    />
                    )}
                  </div>
                  {showRealocationDateField && (
                    <SelectField
                      {...register('realocationProvider')}
                      fieldName="fornecedor realocação"
                      onChange={(value) => handleInput('realocationProvider', value)}
                      initialValue={{
                        value:
                          activeItemName && activeItemName[0]
                            ? activeItemName[0].realocation_provider
                            : null,
                        label:
                          activeItemName && activeItemName[0]
                            ? activeItemName[0].realocation_provider
                            : null
                      }}
                      options={options}
                    />
                  )}
                  <div className="checkbox_container">
                    <CheckBoxField
                      {...register('reseal')}
                      onChange={(value) => handleInput('reseal', value)}
                      fieldName="Relacre"
                      initialValue={
                        activeItemName[0] && activeItemName[0].reseal === 1
                          ? true
                          : false
                      }
                    />
                    {showResealDateField && (
                      <TextField
                        {...register('resealDate')}
                        type="date"
                        onChange={(value) => handleInput('resealDate', value)}
                        fieldName="data relacre"
                        initialValue={
                          activeItemName && activeItemName[0]
                            ? activeItemName[0].reseal_date
                            : null
                        }
                      />
                    )}
                  </div>
                </Col>
              </Row>
              <div className="button-container">
                <Button color="primary">Salvar</Button>
              </div>
            </form>
          ) : (
            <Spinner />
          )}
        </Container>
      </S.Wrapper>
    </>
  )
}

export default FormRealocation